import currencyFormatter from 'currency-formatter'
import { DEFAULT_CURRENCY } from '../../constants'
import { MAXIMUM_FRACTION_DIGITS_BY_CURRENCY, PRICE_LOCALE_BY_CURRENCY } from '../../mappings'

const CURRENCY_SIGN = {
  USD: '$',
  EUR: '€',
  GBP: '£',
  JPY: '¥',
  UAH: '₴',
  RUB: '₽',
}

export const getCurrencySign = currency => {
  return CURRENCY_SIGN[currency] || currency
}
export const getPriceGross = (price, currency) => {
  return `${getCurrencySign(currency)}${parseFloat(price).toFixed(2)}`
}

type TPrice = {
  amount: number
  currency?: string
}

export const showPrice = (price: TPrice): string => {
  const { amount, currency } = price

  return new Intl.NumberFormat(PRICE_LOCALE_BY_CURRENCY[currency.toUpperCase()] || 'en-US', {
    style: 'currency',
    currency: currency.toUpperCase(),
    currencyDisplay: 'narrowSymbol',
    maximumFractionDigits: MAXIMUM_FRACTION_DIGITS_BY_CURRENCY[currency.toUpperCase()],
  }).format(amount)
}
